import { hasOrderedApprovalSteps } from 'ui-product-approvals-common';
export const useHasOrderedApprovalSteps = approvalType => hasOrderedApprovalSteps({
  approvalType
});